export const BookDetailSymbol = Symbol('bookDetail');
